import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceStatus } from '../../enums';
import { InvoiceStatusPipe } from '../../pipes';

@Component({
  selector: 'app-invoice-status',
  imports: [CommonModule, InvoiceStatusPipe],
  templateUrl: './invoice-status.component.html',
  styleUrl: './invoice-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceStatusComponent {
  public readonly status = input.required<InvoiceStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case InvoiceStatus.New:
        return 'text-lime-600';

      case InvoiceStatus.Generated:
        return 'text-sky-700';

      case InvoiceStatus.Failed:
        return 'text-red-600';

      default:
        return '';
    }
  });
}
